const DEFAULT_PERMISSIONS = {
  canCreateAgent: false,
  canChangeAgentStatus: false,
  canViewAgent: true,
  canEditAgent: false,
  canChangePassword: false,
  canManageGroups: false,
};

const SUBROLE_PERMISSIONS = {
  owner: {
    canCreateAgent: true,
    canChangeAgentStatus: true,
    canViewAgent: true,
    canEditAgent: true,
    canChangePassword: true,
    canManageGroups: true,
  },
};

export const getAgentManagementPermissions = (subrole) => {
  const normalizedSubrole = String(subrole || '').trim().toLowerCase();
  const rolePermissions = SUBROLE_PERMISSIONS[normalizedSubrole] || {};

  return {
    ...DEFAULT_PERMISSIONS,
    ...rolePermissions,
  };
};
